<template>
  <div class="logo-image-wrapper">
    <svg
      class="logo-svg_icon"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      :class="isMinified ? 'logo-svg_icon--minified' : ''"
    >
      <mask id="mask0_icon" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="70" height="70">
        <rect width="70" height="70" rx="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_icon)">
        <rect x="-14" y="-12" width="93" height="95" fill="url(#paint0_icon_linear)" />
        <rect
          x="40.4551"
          y="30.1499"
          width="9"
          height="47.9814"
          rx="4"
          transform="rotate(30 40.4551 30.1499)"
          fill="#FF8800"
          fill-opacity="0.66"
        />
        <rect
          x="60.3643"
          y="16.5483"
          width="9"
          height="52.551"
          rx="4"
          transform="rotate(30 60.3643 16.5483)"
          fill="#FF9407"
        />
        <rect
          x="72.6953"
          y="16.0737"
          width="9"
          height="23.2483"
          rx="4"
          transform="rotate(30 72.6953 16.0737)"
          fill="#FF8707"
        />
        <rect
          x="88.5918"
          y="9.42236"
          width="9"
          height="59.4055"
          rx="4"
          transform="rotate(30 88.5918 9.42236)"
          fill="#FF9407"
        />
        <rect
          x="6.08301"
          y="6.15186"
          width="9"
          height="30.5336"
          rx="4"
          transform="rotate(30 6.08301 6.15186)"
          fill="#FFA007"
        />
        <rect
          x="16.5791"
          y="8.85449"
          width="9"
          height="33.4415"
          rx="4"
          transform="rotate(30 16.5791 8.85449)"
          fill="#FF9407"
        />
        <rect
          x="30.5088"
          y="5.61084"
          width="9"
          height="43.2144"
          rx="4"
          transform="rotate(30 30.5088 5.61084)"
          fill="#FD8E3E"
        />
        <rect
          x="33.5859"
          y="21.1646"
          width="9"
          height="37.8035"
          rx="4"
          transform="rotate(30 33.5859 21.1646)"
          fill="#FF9407"
        />
      </g>
      <path
        d="M24 19V51C24.1667 46.6667 26.9 37.5 36.5 37.5C46.1 37.5 47.5 46.5 47.5 51"
        stroke="black"
        stroke-width="8"
      />
      <defs>
        <linearGradient id="paint0_icon_linear" x1="32" y1="-12" x2="27" y2="83" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFB700" />
          <stop offset="1" stop-color="#F86801" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-if="!isMinified"
      class="logo-svg logo-svg--text"
      viewBox="75 15 114 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      preserveAspectRatio="xMinYMid meet"
    >
      <path
        d="M175.232 44.0203C174.366 44.0203 173.488 43.9204 172.6 43.7205C171.711 43.5206 170.878 43.1874 170.101 42.721C169.346 42.2545 168.702 41.6215 168.169 40.8219C167.636 40.0001 167.28 38.9783 167.103 37.7567H173.066C173.155 38.0454 173.311 38.3009 173.533 38.523C173.777 38.7451 174.066 38.9228 174.399 39.0561C174.754 39.1671 175.132 39.2226 175.532 39.2226C175.798 39.2226 176.032 39.2004 176.231 39.156C176.454 39.1116 176.642 39.045 176.798 38.9561C176.953 38.8451 177.064 38.7229 177.131 38.5896C177.22 38.4564 177.264 38.312 177.264 38.1565C177.264 37.8455 177.142 37.6234 176.898 37.4901C176.653 37.3347 176.32 37.2236 175.898 37.157C175.476 37.0681 174.999 36.9682 174.466 36.8571C173.644 36.6794 172.755 36.4573 171.8 36.1908C170.867 35.902 170.079 35.5466 169.435 35.1246C169.102 34.9025 168.813 34.6582 168.568 34.3916C168.346 34.1029 168.158 33.7919 168.002 33.4588C167.869 33.1256 167.769 32.7813 167.702 32.4259C167.636 32.0705 167.602 31.6929 167.602 31.2931C167.602 30.2714 167.824 29.4163 168.269 28.7277C168.735 28.0169 169.324 27.4505 170.034 27.0285C170.767 26.6065 171.567 26.3066 172.433 26.129C173.322 25.9291 174.188 25.8291 175.032 25.8291C176.276 25.8291 177.431 26.029 178.497 26.4288C179.585 26.8286 180.485 27.4728 181.196 28.3612C181.929 29.2497 182.384 30.4269 182.562 31.8928H176.864C176.82 31.493 176.598 31.1821 176.198 30.96C175.821 30.7378 175.354 30.6268 174.799 30.6268C174.577 30.6268 174.366 30.649 174.166 30.6934C173.988 30.7378 173.822 30.7934 173.666 30.86C173.533 30.9266 173.422 31.0155 173.333 31.1265C173.266 31.2376 173.233 31.3598 173.233 31.493C173.233 31.5819 173.255 31.6818 173.3 31.7929C173.366 31.904 173.477 32.015 173.633 32.1261C173.788 32.2149 173.999 32.3038 174.266 32.3926C174.999 32.5703 175.687 32.7258 176.331 32.859C176.998 32.9923 177.664 33.1256 178.33 33.2589C179.063 33.3921 179.785 33.6253 180.496 33.9585C181.207 34.2695 181.795 34.747 182.262 35.3912C182.751 36.0353 182.995 36.9349 182.995 38.0899C182.995 39.2226 182.762 40.1777 182.295 40.9551C181.829 41.7103 181.207 42.31 180.429 42.7543C179.674 43.1985 178.841 43.5206 177.931 43.7205C177.02 43.9204 176.12 44.0203 175.232 44.0203Z"
        fill="currentColor"
      />
      <path
        d="M160.958 43.9872C158.892 43.9872 157.315 43.3986 156.227 42.2213C155.139 41.0441 154.594 39.4671 154.594 37.4903V31.4599H152.129V26.1957H154.594V21.7979H160.492V26.1957H165.756V31.4599H160.492V36.1243C160.492 36.6129 160.569 37.035 160.725 37.3903C160.902 37.7235 161.158 37.9789 161.491 38.1566C161.846 38.3343 162.28 38.4232 162.79 38.4232C163.346 38.4232 163.801 38.3454 164.156 38.19C164.512 38.0123 164.801 37.8346 165.023 37.6569L166.622 42.288C166.111 42.71 165.511 43.0543 164.823 43.3208C164.156 43.5651 163.479 43.7317 162.79 43.8206C162.124 43.9316 161.513 43.9872 160.958 43.9872Z"
        fill="currentColor"
      />
      <path
        d="M144.317 43.7543V26.1961H150.215V43.7543H144.317ZM147.283 24.9966C146.217 24.9966 145.35 24.6857 144.684 24.0637C144.04 23.4196 143.718 22.5867 143.718 21.565C143.718 20.521 144.062 19.6659 144.751 18.9995C145.439 18.3332 146.294 18 147.316 18C148.293 18 149.126 18.3221 149.815 18.9662C150.503 19.5881 150.848 20.4433 150.848 21.5316C150.848 22.5756 150.515 23.4196 149.848 24.0637C149.204 24.6857 148.349 24.9966 147.283 24.9966Z"
        fill="currentColor"
      />
      <path
        d="M132.44 43.7535V31.4594H129.941V26.1953H132.44V24.796C132.44 23.4189 132.673 22.2972 133.14 21.4309C133.606 20.5647 134.317 19.9316 135.272 19.5318C136.249 19.132 137.46 18.9321 138.904 18.9321H142.402V24.1629H139.67C139.359 24.1629 139.104 24.2074 138.904 24.2962C138.704 24.3851 138.559 24.5294 138.471 24.7293C138.382 24.907 138.337 25.1291 138.337 25.3957V26.1953H142.402V31.4594H138.337V43.7535H132.44Z"
        fill="currentColor"
      />
      <path
        d="M119.984 44.0203C118.251 44.0203 116.685 43.6761 115.286 42.9875C113.909 42.2989 112.809 41.2883 111.988 39.9556C111.166 38.6007 110.755 36.9571 110.755 35.0247C110.755 33.0478 111.166 31.382 111.988 30.0271C112.832 28.65 113.942 27.606 115.319 26.8953C116.696 26.1845 118.218 25.8291 119.884 25.8291C121.594 25.8291 123.127 26.1956 124.482 26.9286C125.859 27.6616 126.947 28.7166 127.747 30.0937C128.569 31.4708 128.979 33.1478 128.979 35.1246C128.979 37.0348 128.591 38.6563 127.813 39.9889C127.036 41.3216 125.97 42.3323 124.615 43.0208C123.26 43.6872 121.716 44.0203 119.984 44.0203ZM119.884 38.5563C120.728 38.5563 121.394 38.3786 121.883 38.0232C122.372 37.6678 122.716 37.2236 122.916 36.6905C123.116 36.1352 123.216 35.5911 123.216 35.058C123.216 34.5249 123.116 33.9696 122.916 33.3921C122.716 32.8146 122.372 32.326 121.883 31.9262C121.416 31.5264 120.75 31.3265 119.884 31.3265C119.04 31.3265 118.362 31.5264 117.851 31.9262C117.363 32.326 117.019 32.8146 116.819 33.3921C116.619 33.9474 116.519 34.5027 116.519 35.058C116.519 35.6133 116.619 36.1686 116.819 36.7239C117.041 37.2569 117.396 37.7012 117.885 38.0565C118.373 38.3897 119.04 38.5563 119.884 38.5563Z"
        fill="currentColor"
      />
      <path
        d="M98.2148 43.7538V26.1956H103.379L103.779 27.8615C104.223 27.2173 104.712 26.7509 105.245 26.4621C105.778 26.1734 106.311 25.9957 106.844 25.9291C107.377 25.8624 107.866 25.8291 108.31 25.8291C108.688 25.8291 109.032 25.8402 109.343 25.8624C109.654 25.8624 109.854 25.8735 109.943 25.8957V31.593H108.81C107.988 31.593 107.211 31.7041 106.478 31.9262C105.767 32.1261 105.189 32.5259 104.745 33.1256C104.323 33.7031 104.112 34.5804 104.112 35.7577V43.7538H98.2148Z"
        fill="currentColor"
      />
      <path
        d="M77 50.4506V26.1956H82.464L82.7639 28.128C83.5635 27.2617 84.3853 26.662 85.2294 26.3289C86.0734 25.9957 87.0285 25.8291 88.0947 25.8291C89.7827 25.8291 91.1932 26.24 92.3259 27.0618C93.4587 27.8615 94.3139 28.9498 94.8914 30.3269C95.4689 31.6818 95.7576 33.2033 95.7576 34.8914C95.7576 36.6239 95.4467 38.1787 94.8247 39.5558C94.225 40.9329 93.3255 42.0213 92.126 42.8209C90.9488 43.6205 89.5051 44.0203 87.7948 44.0203C87.1062 44.0203 86.4399 43.9315 85.7958 43.7538C85.1738 43.5983 84.6074 43.3873 84.0966 43.1208C83.6079 42.8542 83.2081 42.5655 82.8972 42.2545V50.4506H77ZM86.5954 38.6563C87.4838 38.6563 88.1724 38.4675 88.661 38.0899C89.1497 37.7123 89.4829 37.2458 89.6606 36.6905C89.8605 36.1352 89.9604 35.6022 89.9604 35.0913C89.9604 34.4916 89.8494 33.8919 89.6272 33.2922C89.4051 32.6925 89.0386 32.2038 88.5278 31.8262C88.0391 31.4264 87.3617 31.2265 86.4954 31.2265C85.6958 31.2265 85.0295 31.4153 84.4964 31.7929C83.9633 32.1483 83.5635 32.6147 83.297 33.1922C83.0304 33.7475 82.8972 34.3361 82.8972 34.958C82.8972 35.5577 83.0193 36.1464 83.2636 36.7239C83.5302 37.2791 83.93 37.7456 84.4631 38.1232C85.0184 38.4786 85.7291 38.6563 86.5954 38.6563Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'LogoImage',
  props: {
    isMinified: {
      type: Boolean,
      required: true,
    },
    platform: {
      type: String,
      default: process.env.PLATFORM,
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-image-wrapper {
  --logo-icon-width: 38px;
  --logo-icon-width-minified: 38px;
  --logo-text-height: 26px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 0;
  width: 100%;
  height: 100%;
  color: var(--bs-body-color);
}

.logo-svg_icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: var(--logo-icon-width);
  height: auto;
  transition: width 0.1s ease-in-out;
}

.logo-svg_icon--minified {
  width: var(--logo-icon-width-minified);
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-svg--text {
  margin-left: 5px;
  transition: width 0.1s ease-in-out;
  width: 100%;
  max-height: var(--logo-text-height);
}
</style>
